import { SideBarNotification } from '@app/core/models';
import { createFeatureSelector, createReducer, on } from '@ngrx/store';
import { getSideBarNotificationListSuccess } from '../actions/side-bar-notification.actions';

export interface SideBarNotificationState {
  sideBarNotificationList?: SideBarNotification[];
}

const initialState: SideBarNotificationState = {
  sideBarNotificationList: []
};

export const sideBarNotificationStateReducer = createReducer(
  initialState,
  on(getSideBarNotificationListSuccess, (state, action) => ({ ...state, sideBarNotificationList: action.payload })),
);

export const selectSideBarNotificationState = createFeatureSelector<SideBarNotificationState>('sideBarNotificationState');
